import { render, staticRenderFns } from "./ProdutoImagemShow.vue?vue&type=template&id=72af67c8"
import script from "./ProdutoImagemShow.vue?vue&type=script&lang=js"
export * from "./ProdutoImagemShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports